"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Accent_1 = require("@nerdwallet/currency/components/Accent");
var Box_1 = require("@nerdwallet/currency/components/Box");
var Link_1 = require("@nerdwallet/currency/components/Link");
var Text_1 = require("@nerdwallet/currency/components/Text");
var Stack_1 = require("@nerdwallet/currency/components/Stack");
var Help_1 = __importDefault(require("@nerdwallet/react-icon/nerdwallet-ui/Help"));
var nerdwallet_plus_logo_1 = require("../nerdwallet-plus-logo");
var nw_plus_tooltip_1 = __importDefault(require("../tooltip/nw-plus-tooltip"));
var product_card_banner_module_css_1 = __importDefault(require("./product-card-banner.module.css"));
var drawer_context_1 = require("../nerdwallet-plus-drawer-sticky-button/drawer-context");
var variables_1 = require("../../styles/variables");
var ProductCardBanner = function (_a) {
    var text = _a.text, tooltipCtaOnClick = _a.tooltipCtaOnClick, tooltipOnClick = _a.tooltipOnClick, tooltipText = _a.tooltipText, _b = _a.tooltipCtaText, tooltipCtaText = _b === void 0 ? "About NerdWallet+" : _b;
    var open = (0, drawer_context_1.useDrawerContext)().open;
    var _c = (0, react_1.useState)(false), isTooltipOpen = _c[0], setIsTooltipOpen = _c[1];
    var handleTooltipCtaClick = function () {
        if (tooltipCtaOnClick) {
            tooltipCtaOnClick();
        }
        setIsTooltipOpen(false);
        open();
    };
    var fullTooltipText = (react_1.default.createElement(Stack_1.Stack, { spacing: 3 },
        react_1.default.createElement(Text_1.Text, null, tooltipText),
        react_1.default.createElement(Link_1.Link, { onClick: handleTooltipCtaClick },
            react_1.default.createElement(Accent_1.Accent, null, tooltipCtaText))));
    return (react_1.default.createElement(Box_1.Box, { className: product_card_banner_module_css_1.default.container, paddingY: 1 },
        react_1.default.createElement(Box_1.Box, { paddingLeft: 3, display: "flex" },
            react_1.default.createElement(nerdwallet_plus_logo_1.NerdWalletPlusLogo, { small: true, width: 19, height: 10 })),
        react_1.default.createElement(Box_1.Box, { paddingLeft: 1 }, text),
        react_1.default.createElement(Box_1.Box, { paddingX: 1 },
            react_1.default.createElement(nw_plus_tooltip_1.default, { ariaLabel: "NerdWallet+ Tooltip", onOpen: tooltipOnClick, isOpen: isTooltipOpen, setIsOpen: setIsTooltipOpen, text: fullTooltipText, trigger: react_1.default.createElement(Help_1.default, { size: 10, color: variables_1.colors["green-darkest"] }) }))));
};
exports.default = ProductCardBanner;
